import './index.scss';
import React, { useEffect } from 'react';
import { Global, ThemeProvider, css } from '@emotion/react';
import { ErrorBoundary } from '@datadog/browser-rum-react';

import { useTranslation } from 'react-i18next';
import i18n from './features/i18n';
import { useTheme } from './hooks';
import { withFoundationOverrides } from './theme';
import { Main, Oops } from './screens';
import { FormContextProvider } from './state';
import { SegmentContextProvider } from './features/segment-context';
import { CaptchaContextProvider } from './features/captcha-context';
import { loadTreatwellCookieConsent } from './helpers/cookie';

export function App() {
  const theme = useTheme();
  const { t } = useTranslation('global');

  useEffect(() => {
    // Change the locale to match the browser's
    i18n.changeLanguage(navigator.language);
    // Set the html tag's lang attribute for onetrust to display in the correct locale
    document.documentElement.lang = navigator.language;

    // Load onetrust script
    loadTreatwellCookieConsent();
  }, []);

  useEffect(() => {
    document.title = t('title');
  }, [t]);

  if (!theme) {
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <SegmentContextProvider>
        <ErrorBoundary fallback={Oops}>
          <CaptchaContextProvider>
            <FormContextProvider>
              <Main />
            </FormContextProvider>
          </CaptchaContextProvider>
        </ErrorBoundary>
      </SegmentContextProvider>
      <Global
        styles={css`
          ${withFoundationOverrides(theme.css)}
        `}
      />
    </ThemeProvider>
  );
}
